import { render, staticRenderFns } from "./ResearchSingleCellInfo.vue?vue&type=template&id=7eaefaac&scoped=true&"
import script from "./ResearchSingleCellInfo.vue?vue&type=script&lang=js&"
export * from "./ResearchSingleCellInfo.vue?vue&type=script&lang=js&"
import style0 from "./ResearchSingleCellInfo.vue?vue&type=style&index=0&id=7eaefaac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaefaac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eaefaac')) {
      api.createRecord('7eaefaac', component.options)
    } else {
      api.reload('7eaefaac', component.options)
    }
    module.hot.accept("./ResearchSingleCellInfo.vue?vue&type=template&id=7eaefaac&scoped=true&", function () {
      api.rerender('7eaefaac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/singleCellBrowser/ResearchSingleCellInfo.vue"
export default component.exports